import React from "react";
import DestinationItem from "./DestinationItem";
import {RouteIcon} from "../../assets";
import {Button} from "../../ui-components";
import {PanelPopover} from "../../shared";
import {togglePopover} from "../../app/app-slice";
import {ActionsPopovers, ActionsTooltip} from "../emergencyCall/components";
import {useAppDispatch, useAppSelector} from "../../core/hooks";
import AddDestinationForm from "./DcScheduledCall/addDestination";

const DestinationsContainer = ({isEditable, request}) => {
  const app = useAppSelector(state => state.app)
  const dispatch = useAppDispatch()
  const { er_call } = useAppSelector(state => state.requests)


  return <>
    <div style={{display: "flex", marginTop: 20, alignItems: "center", padding: "8px 24px"}}>
      <RouteIcon  className='mr-5'/>
      <div style={{    fontFamily: "Manrope Semibold",
        color: "rgb(25, 34, 51)",
        fontSize: 16,
        fontWeight: 700,
        overflowWrap: "break-word"}}>Пункт назначения</div>
    </div>
    {request && request.destination && request.destination.map((destination, index, destArray) => {
    return <DestinationItem isEditable={isEditable} destination={destination} index={index} lastElement={destArray.length} />
    })

}
<div style={{padding: 24}}>
  {/* eslint-disable-next-line no-mixed-operators */}
  {!isEditable && er_call?.status !== 12 && <Button fullWidth
           onClick={() => {
             dispatch(togglePopover('destinationsFormOpen'))
           }}
           type={'contained'}>➕ Дополнительный пункт назначения</Button>}
  <PanelPopover open={app.popoverFormStatuses.destinationsFormOpen}
                className='diagnose-popover'
                title={'Добавить пункт назначения'}
                handleClose={() => dispatch(togglePopover('destinationsFormOpen'))}>
    <AddDestinationForm/>
  </PanelPopover>
</div>
</>
}

export default DestinationsContainer
